export default "__VITE_ASSET__0cyZoTsO__"